import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../store';
import { BelfiusButton, BelfiusTextInput } from '../../components/custom';

import { Dispatch } from 'redux';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import styles from './ChangePassword.module.css';
import { updatePassword } from '../../store/login';
import BelfiusButtonWrapper from '../../components/custom/belfius-button-wrapper';

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  readonly updatePassword: typeof updatePassword;
}

interface PropsFromState {
  readonly errorMessage: string;
  readonly showLoader: boolean;
  readonly currentLanguage: string;
}

interface State {
  readonly currentPassword: string;
  readonly newPassword: string;
  readonly confirmNewPassword: string;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class ChangePassword extends React.Component<AllProps, State> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
    this.localization.setLanguage(this.props.currentLanguage);
    this.state = {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    };
  }


  updatePassword = () => {
    this.props.updatePassword(this.state.currentPassword, this.state.newPassword, this.state.confirmNewPassword);
  }

  setUserField = (field: 'currentPassword' | 'newPassword' | 'confirmNewPassword', value: string): void => {
    switch (field) {
      case 'currentPassword':
        this.setState({ ...this.state, currentPassword: value });
        break;
      case 'newPassword':
        this.setState({ ...this.state, newPassword: value });
        break;
      case 'confirmNewPassword':
        this.setState({ ...this.state, confirmNewPassword: value });
        break;
      default:
        break;
    }
  }

  public render() {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.logoContainer}>
            <div className={styles.logo}>
              <a href='http://www.zamia.be' target='_blank' rel="noreferrer"><img alt="" className={styles.logo} src={require('../../assets/images/login.png')} /></a>
            </div>
          </div>
          <div id='loader' className={styles.updatePasswordContainer}>
            <div className={styles.logo}>
              <img alt="" hidden={!this.props.showLoader} src={require('../../assets/images/spinnerLoaderGray.gif')} />
            </div>
          </div>
          <div className={styles.formContainer}>
            <span className={styles.passwordPolicyInfo}>{this.localization.get('changePassword.passwordPolicyInfo')}</ span>
            <BelfiusTextInput
              type='password'
              className={styles.currentPassword}
              value={this.state.currentPassword}
              placeholder={this.localization.get('changePassword.currentPassword')}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                this.setUserField('currentPassword', event.target.value)} />
            <BelfiusTextInput
              type='password'
              className={styles.newPassword}
              value={this.state.newPassword}
              placeholder={this.localization.get('changePassword.newPassword')}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                this.setUserField('newPassword', event.target.value)} />
            <BelfiusTextInput
              type='password'
              className={styles.confirmNewPassword}
              value={this.state.confirmNewPassword}
              placeholder={this.localization.get('changePassword.confirmNewPassword')}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                this.setUserField('confirmNewPassword', event.target.value)} />
            <span className={styles.errorMessage}>{this.localization.get(this.props.errorMessage)}</ span>
            <BelfiusButton
              className={styles.updatePasswordButton}
              onClick={() => this.updatePassword()}
              title={this.localization.get('changePassword.confirm.button')} />
            <BelfiusButtonWrapper
              className={styles.cancelButton}
              navigateTo='/'
              title={this.localization.get('changePassword.cancel.button')} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ login, shared }: ApplicationState): PropsFromState => ({
  errorMessage: login.errorMessage,
  showLoader: login.showLoader,
  currentLanguage: shared.currentLanguage
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updatePassword: (currentPassword: string, newPassword: string, confirmNewPassword: string) => dispatch(updatePassword(currentPassword, newPassword, confirmNewPassword))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);
